import { Link } from "react-router-dom";
import { Container, Row, Col, List } from "reactstrap";

const MemberListBanner = (props: any) => {
  return (
    <>
      <section className="page-banner">
        <div className="page-banner-wrap">
          <Container>
            <Row>
              <Col lg={12} xs={12}>
                <div className="heading-wrap">
                  <h1>Accomodation</h1>
                </div>
                <nav aria-label="breadcrumb">
                  <List className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <Link to="/accomodation"> Accomodation</Link>
                    </li>
                    {/* <li className="breadcrumb-item active" aria-current="page">
                      {props?.doctor_name}
                    </li> */}
                  </List>
                </nav>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
};

export default MemberListBanner;
